import api from "./api"

export const getOrganizations = async () => {
  const response = await api.get("/organizations")
  return response.data
}

export const getActiveOrganizations = async () => {
  const response = await api.get("/organizations/active")
  return response.data
}

export const getOrganization = async (id) => {
  const response = await api.get(`/organizations/${id}`)
  return response.data
}

export const getCurrentOrganization = async () => {
  const response = await api.get("/organizations/current")
  return response.data
}

export const createOrganization = async (organizationData) => {
  try {
    console.log("Sending organization data to API:", organizationData)
    const response = await api.post("/organizations", organizationData)
    console.log("API response:", response.data)
    return response.data
  } catch (error) {
    console.error("API error creating organization:", error)
    throw error
  }
}

export const updateOrganization = async (id, organizationData) => {
  const response = await api.put(`/organizations/${id}`, organizationData)
  return response.data
}

export const deleteOrganization = async (id) => {
  const response = await api.delete(`/organizations/${id}`)
  return response.data
}

export const getOrganizationUsers = async (id) => {
  const response = await api.get(`/organizations/${id}/users`)
  return response.data
}

export const getOrganizationStats = async (id) => {
  const response = await api.get(`/organizations/${id}/stats`)
  return response.data
}

